import React from 'react';
import { ApButtonIcon, ApButtonMain } from '@alixpartners/ui-components';
import { Backdrop, ModalNameContainer, ModalHeader } from './ClientModal.style';
import { Footer } from 'components/Modal/styles';

const ClientNameModal = ({
	children,
	onClose,
	title,
	onSubmit,
	clientName,
}) => {
	return (
		<Backdrop>
			<ModalNameContainer>
				<ModalHeader>
					<div style={{ flex: 1 }}>{title}&nbsp;</div>
					<ApButtonIcon
						title="Close"
						iconName="close"
						onClick={() => onClose(false)}
					/>
				</ModalHeader>
				{children}
				<Footer>
					<div style={{ margin: '10px' }}>
						<ApButtonMain
							style={{ height: '30px' }}
							onClick={onSubmit}
							disabled={clientName.length === 0}
						>
							Send Mail
						</ApButtonMain>
					</div>
				</Footer>
			</ModalNameContainer>
		</Backdrop>
	);
};

export default ClientNameModal;
